import { stringify } from 'query-string';

interface ISocialTopPostsURLArgs {
  entityIds: string[];
  platformFilter?: string;
  metricIds?: string[];
  download?: boolean;
}

export default function getSocialTopPostsURL(
  args: ISocialTopPostsURLArgs
): string {
  const { entityIds, platformFilter, metricIds, download } = args;

  const params = stringify({
    download,
    platformFilter,
    metricIds,
  });

  return `/api/social/post/top/artist/${entityIds}?${params}`;
}
